import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-campanha-pipeline-card-info-nao-confirmada',
    templateUrl: './campanha-pipeline-card-info-nao-confirmada.component.html',
    styleUrls: ['./campanha-pipeline-card-info-nao-confirmada.component.less']
})
export class CampanhaPipelineCardInfoNaoConfirmadaComponent {
    @Input() createdAt: Date;
    @Input() idUsuarioCreated: number;
    @Input() avatarURLUsuarioCreated: string;
    @Input() nomeUsuarioCreated: string;
}
